import { FormControl, Stack, Spinner, RadioGroup, Radio, FormErrorMessage } from '@chakra-ui/react'
import { useFormContext, Controller } from 'react-hook-form'

import { FormLabel } from '../../components/FormLabel'
import { RadioStack } from '../../components/RadioStack'

import { SelectionType } from 'brokertslib/src/enums'
import { useSelections } from '../../hooks'
import { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos/Travel'

export const TripKind = ({ isContracted }: { isContracted: boolean }) => {
  const { control, formState: {errors} } = useFormContext<InsuranceParamsTravelDto>()

  const { data: dataTravelType, isLoading: isLoadingTravelType, isFetching: isFetchingTravelType } = useSelections(SelectionType.TravelType)

  return (
    <FormControl isRequired isInvalid={!!errors.travel?.travelType}>
      <Stack direction={'row'}>
        <FormLabel>Druh cesty</FormLabel>
        {(isFetchingTravelType || isLoadingTravelType) && <Spinner />}
      </Stack>
      <Controller
        name="travel.travelType"
        control={control}
        render={({ field: { onChange, value } }) => (
          <RadioGroup onChange={e => onChange(parseInt(e))} value={value?.toString() ?? ''} isDisabled={isContracted}>
            <RadioStack variant="stackedTile">
              {dataTravelType?.data.map((item) => (
                <Radio value={item.id.toString()} key={item.id}>
                  {item.description}
                </Radio>
              ))}
            </RadioStack>
          </RadioGroup>
        )}
      />
      {errors.travel?.travelType && <FormErrorMessage>{errors.travel.travelType.message}</FormErrorMessage>}
    </FormControl>
  )
}
